import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from './axiosConfig';

const TemperatureUnitContext = createContext();

export const TemperatureUnitProvider = ({ projectId, children }) => {
  const [temperatureUnit, setTemperatureUnit] = useState('Celsius');

  useEffect(() => {
    const fetchTemperatureUnit = async () => {
      try {
        const response = await axiosInstance.get(`/api/projects/${projectId}/settings`);
        setTemperatureUnit(response.data.temperature_unit || 'Celsius');
      } catch (error) {
        console.error('Error fetching temperature unit from project settings:', error);
      }
    };

    if (projectId) {
      fetchTemperatureUnit();
    }
  }, [projectId]);

  const convertTemperature = (value) => {
    if (temperatureUnit === 'Fahrenheit') {
      return ((value * 9) / 5 + 32).toFixed(2); // Limita el valor a dos decimales en Fahrenheit
    }
    return value.toFixed(2); // Limita el valor a dos decimales en Celsius
  };

  return (
    <TemperatureUnitContext.Provider value={{ temperatureUnit, convertTemperature }}>
      {children}
    </TemperatureUnitContext.Provider>
  );
};

// Exporta solo el hook y el proveedor
export const useTemperatureUnit = () => useContext(TemperatureUnitContext);
